'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

import { parseVideoEditDeepLink, VIDEO_EDIT_PATH, type VideoEditDeepLink } from './videoEditDeepLink';

/**
 * Reads the stock item a StockBlocks "Edit with AI" button handed over in the query string.
 */
export function useVideoEditDeepLink(): VideoEditDeepLink | null {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    return useMemo(() => {
        // The provider is mounted by the shared /ai layout, so scope this to the editor's own route.
        if (pathname !== VIDEO_EDIT_PATH) {
            return null;
        }

        return parseVideoEditDeepLink(Object.fromEntries(searchParams ?? []));
    }, [pathname, searchParams]);
}
